import { useTranslation } from 'react-i18next';
import { BaseModal, BaseModalProps } from '@anytag/shared-atoms';

export interface ConfirmDeleteModalProps extends Omit<BaseModalProps, 'open'> {
  deleting?: boolean;
  onDelete?: () => void;
  deletingItem?: { id: number; name: string } | null;
}

export const ConfirmDeleteModal = ({
  footer,
  onClose,
  deleting,
  onDelete,
  deletingItem,
  ...restProps
}: ConfirmDeleteModalProps) => {
  const { t } = useTranslation();

  return (
    <BaseModal
      onClose={onClose}
      open={!!deletingItem}
      title={`${t('Dialog.Are you sure you want to delete', { name: deletingItem?.name })}?`}
      footer={{
        ...footer,
        cancelButton: { onClick: onClose, ...footer?.cancelButton },
        submitButton: { title: t('Button.Delete'), onClick: onDelete, loading: deleting, ...footer?.submitButton }
      }}
      {...restProps}
    />
  );
};
